import { render, staticRenderFns } from "./EditLabelButton.vue?vue&type=template&id=0450caea&"
import script from "./EditLabelButton.vue?vue&type=script&lang=js&"
export * from "./EditLabelButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports